// The DESIGN.md icon set: inline SVG, 20x20 grid, stroke 1.6, round caps and joins.
import type { SVGProps } from "react";

const PATHS = {
  today: <><rect x="3" y="4" width="14" height="13" rx="2" /><path d="M3 8h14M7 2v4M13 2v4" /><path d="M7 12h2" /></>,
  calendar: <><rect x="3" y="4" width="14" height="13" rx="2" /><path d="M3 8h14M7 2v4M13 2v4" /></>,
  patients: <><circle cx="8" cy="7" r="3" /><path d="M2.5 17c0-3 2.5-5 5.5-5s5.5 2 5.5 5" /><circle cx="14.5" cy="8" r="2.2" /><path d="M14 12.5c2.3.2 3.8 1.8 3.8 4" /></>,
  orders: <><path d="M4 5h12l-1 9H5z" /><path d="M7 5V4a3 3 0 0 1 6 0v1" /><path d="M8 17h4" /></>,
  invoices: <><path d="M5 2.5h8l3 3v12H5z" /><path d="M13 2.5v3h3" /><path d="M8 9h5M8 12h5M8 15h3" /></>,
  lab: <><circle cx="6" cy="10.5" r="3.5" /><circle cx="14" cy="10.5" r="3.5" /><path d="M9.5 10.5h1M2.5 9.5l-1-2M17.5 9.5l1-2" /></>,
  purchasing: <><path d="M3 4h2l1.5 9h9L17 6H6" /><circle cx="8" cy="16" r="1.2" /><circle cx="14" cy="16" r="1.2" /></>,
  stock: <><path d="M3 6l7-3.5L17 6v8l-7 3.5L3 14z" /><path d="M3 6l7 3.5L17 6M10 9.5V17.5" /></>,
  cash: <><rect x="2.5" y="5" width="15" height="10" rx="2" /><circle cx="10" cy="10" r="2.5" /><path d="M5.5 8v4M14.5 8v4" /></>,
  reports: <><path d="M3 17h14" /><path d="M5 14V9M9 14V5M13 14v-3M17 14V7" /></>,
  settings: <><circle cx="10" cy="10" r="2.5" /><path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.7 4.7l1.4 1.4M13.9 13.9l1.4 1.4M4.7 15.3l1.4-1.4M13.9 6.1l1.4-1.4" /></>,
  search: <><circle cx="9" cy="9" r="5.5" /><path d="M13 13l4.5 4.5" /></>,
  lock: <><rect x="4.5" y="9" width="11" height="8.5" rx="1.5" /><path d="M7 9V6.5a3 3 0 0 1 6 0V9" /></>,
  warning: <><path d="M10 3l7.5 13h-15z" /><path d="M10 8.5v3.5M10 14.5v.5" /></>,
  check: <path d="M4 10.5l4 4 8-9" />,
  plus: <path d="M10 4v12M4 10h12" />,
  chevron: <path d="M7 8l3 3 3-3" />,
  info: <><circle cx="10" cy="10" r="7.5" /><path d="M10 9v5M10 6.5v.5" /></>,
  bell: <><path d="M5 13V9a5 5 0 0 1 10 0v4l1.5 2h-13z" /><path d="M8.5 17a1.5 1.5 0 0 0 3 0" /></>,
  camera: <><path d="M3 7h3l1.5-2h5L14 7h3v9H3z" /><circle cx="10" cy="11.5" r="2.5" /></>,
  // stock-take.html's Stock take and Start stock take: a barcode.
  barcode: <path d="M3 5v10M6 5v10M8.5 5v10M12 5v10M14 5v10M17 5v10" />,
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, ...rest }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
      {PATHS[name]}
    </svg>
  );
}

/** The brand mark: the lab icon at stroke 1.8 on the accent tile. */
export function Mark({ className }: { className?: string | undefined }) {
  return (
    <span className={className ?? "mark"} aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{PATHS.lab}</svg>
    </span>
  );
}
